import { createDuck, createEntityCollection } from '@/utils/'

import {
  getCartInfo,
  changeCartNumber,
  delCartItem,
  batchChangeCartNumber,
} from '@/services/api/wish'
import { Toast } from 'antd-mobile'

//新人活动
export const duck = createDuck({
  name: 'wishCartDuck',
  initialState: {
    cartLoading: 0,
    canBuyList: [],
    canBuyEntry: {},
    expiredList: [],
    postage: {
      itemsTotalPrice: 0,
      discountTotalAmount: 0,
      discountedItemsTotalPrice: 0,
      postFee: 0,
      minFreePostAmount: 0,
    },
    showCart: false,
  },
  actions: {
    fetchCartInfo(level = 0) {
      //getCartInfo
      return async dispatch => {
        const { data } = await getCartInfo()
        if (data) {
          const { canBuyList, expiredList, postage } = data || {}
          const _d =
            Array.isArray(canBuyList) &&
            canBuyList.map(_item => {
              return {
                ..._item,
                originCount: _item.count,
              }
            })
          const { list, entities } = createEntityCollection(_d || [], item => item.subItemId)
          //过滤出 选中商品数量 大于 库存量的
          const _arr = _d.filter(item => {
            const { count, subItemInfo } = item || {}
            const { stockCount } = subItemInfo || {}
            return count > stockCount
          })
          if (_arr.length > 0 && level === 0) {
            const _a = _arr.map(item => {
              const { subItemId, subItemInfo, count } = item || {}
              return {
                subItemId,
                count: subItemInfo.stockCount - count,
              }
            })
            const { error: batchError } = await batchChangeCartNumber(_a)
            if (!batchError) {
              dispatch(duck.fetchCartInfo(1))
            }
          } else {
            dispatch(
              duck.change({
                cartLoading: 1,
                canBuyList: list,
                canBuyEntry: entities,
                expiredList,
                postage,
              }),
            )
          }
        } else {
          dispatch(
            duck.change({
              cartLoading: 1,
              canBuyList: [],
              expiredList: [],
              postage: {},
            }),
          )
        }
      }
    },
    changeCartShow(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            showCart: val,
          }),
        )
      }
    },
    changeNumberLocal(subItemId, val) {
      return (dispatch, getState) => {
        const { wishCartDuck } = getState()
        dispatch(
          duck.merge({
            canBuyEntry: {
              ...wishCartDuck.canBuyEntry,
              [subItemId]: {
                ...wishCartDuck.canBuyEntry[subItemId],
                count: val,
              },
            },
          }),
        )
      }
    },
    changeCartNum(subItemId, count, showToast) {
      return async (dispatch, getState) => {
        const { wishCartDuck } = getState()

        const { error } = await changeCartNumber(subItemId, count)
        if (!error) {
          if (showToast) {
            Toast.show('添加成功，在礼包里等你')
          }
          dispatch(duck.fetchCartInfo())
        } else {
          dispatch(
            duck.merge({
              canBuyEntry: {
                ...wishCartDuck.canBuyEntry,
                [subItemId]: {
                  ...wishCartDuck.canBuyEntry[subItemId],
                  count: wishCartDuck.canBuyEntry[subItemId].originCount,
                },
              },
            }),
          )
          const _msg =
            error.message === '单个子商品最多只能购买99个' ? '可加购数量已达上限' : error.message
          Toast.show(_msg || '更改数量失败')
        }
      }
    },
    delCartItem(subItemIds) {
      return async dispatch => {
        const { error } = await delCartItem(subItemIds)
        if (!error) {
          dispatch(duck.fetchCartInfo())
        } else {
          Toast.show(error.message || '删除心愿单失败')
        }
      }
    },
  },
})
